const NoPage = () => {
    return <div className="Text-center-template">
                <h1>404</h1>
                <p>La pagina non esiste.</p>
                <p>Torna alla <a href="/">Homepage</a></p>
    </div>;
};
  
  export default NoPage;